if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      const template = this.querySelector('template[data-pw-modal-media]');
      if (template) {
        const gallery = opener.closest('media-gallery');
        const slide = opener.closest('[data-color]');
        const color = slide?.dataset.color;
        const slides = gallery ? Array.from(gallery.querySelectorAll('[id^="Slide-"][data-media-id]')) : [];
        const matchingSlides = color ? slides.filter(item => item.dataset.color === color) : slides.filter(item => item.offsetWidth > 0);
        const allowedIds = new Set(matchingSlides.map(item => item.dataset.mediaId.split('-').pop()));
        const container = template.parentElement;
        Array.from(container.children).filter(item => item !== template).forEach(item => item.remove());
        Array.from(template.content.children).forEach(item => {
          if (!allowedIds.size || allowedIds.has(item.dataset.mediaId)) {
            container.appendChild(item.cloneNode(true));
          }
        });
      }
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      if (!activeMedia) return;
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}
